import { TypeUtils } from 'common/utils/generalTypeUtils';
import { ArtistsFilterState } from './store/artists.types';

export const artistsFilterHash = (options: ArtistsFilterState['selectedArtists']): string =>
  TypeUtils.Object.keys(options ?? {})
    .filter((artist) => options[artist])
    .sort()
    .join('_');
